import { render, staticRenderFns } from "./detailTable1.vue?vue&type=template&id=2affb016&scoped=true"
import script from "./detailTable1.vue?vue&type=script&lang=js"
export * from "./detailTable1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2affb016",
  null
  
)

export default component.exports